import { SERVER_URL } from "../../api";
import axios from 'axios';
import FormData from "form-data";
import { getHeaderWithToken } from "../../helpers/func";

export const ADD_SUPPLY_REQUEST = 'ADD_SUPPLY_REQUEST';
export const ADD_SUPPLY_SUCCESS = 'ADD_SUPPLY_SUCCESS';
export const ADD_SUPPLY_ERROR = 'ADD_SUPPLY_ERROR';
export const RESET_ADD_SUPPLY = 'RESET_ADD_SUPPLY';

// data.variants: [{ _id?, optionLabel, image, imageFile?, price, regPrice, onSale,
//                    quantity, weightOz, lowStockThreshold, position, appliesToPatternIds }]
// data.imageFiles: File[] — new product gallery images, only sent when non-empty
export const addSupply = (data, edit) => {
    let headers = getHeaderWithToken();
    const formdata = new FormData();

    if (data.name !== undefined) formdata.append('name', data.name);
    if (data.description !== undefined) formdata.append('description', data.description || '');
    if (data.categoryId !== undefined) formdata.append('categoryId', data.categoryId || '');
    if (data.shopVisible !== undefined) formdata.append('shopVisible', data.shopVisible ? 'true' : 'false');
    if (data.appliesToAll !== undefined) formdata.append('appliesToAll', data.appliesToAll ? 'true' : 'false');
    if (data.requiresShipping !== undefined) formdata.append('requiresShipping', data.requiresShipping ? 'true' : 'false');
    if (data.status !== undefined) formdata.append('status', data.status ? 'true' : 'false');
    if (data.position !== undefined && data.position !== null && data.position !== '') {
        formdata.append('position', data.position);
    }
    if (data.appliesToPatternIds !== undefined) {
        formdata.append('appliesToPatternIds', JSON.stringify(data.appliesToPatternIds || []));
    }

    if (data.variants) {
        const cleanVariants = data.variants.map(v => ({
            _id: v._id,
            optionLabel: v.optionLabel || null,
            image: v.image || null,
            price: v.price,
            regPrice: v.regPrice,
            onSale: v.onSale,
            quantity: v.quantity,
            weightOz: v.weightOz,
            lowStockThreshold: v.lowStockThreshold,
            position: v.position,
            appliesToPatternIds: v.appliesToPatternIds || [],
        }));
        formdata.append('variants', JSON.stringify(cleanVariants));
    }

    // Additive gallery: existingImages is the subset of already-saved photos
    // to keep (whatever the user didn't remove); imageFiles are newly added
    // ones. Sent together so the backend can compute the final array without
    // ever silently dropping photos the user didn't touch.
    if (data.existingImages !== undefined) {
        formdata.append('existingImages', JSON.stringify(data.existingImages));
    }
    if (data.imageFiles && data.imageFiles.length > 0) {
        for (let i = 0; i < data.imageFiles.length; i++) {
            formdata.append('images', data.imageFiles[i]);
        }
    }

    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: ADD_SUPPLY_REQUEST
            })
            axios({
                method: edit ? 'PUT' : 'POST',
                url: edit ? `${SERVER_URL}v1/supply/${data.id}` : `${SERVER_URL}v1/supply`,
                headers: headers,
                data: formdata,
            }).then(function (response) {
                dispatch({
                    type: ADD_SUPPLY_SUCCESS,
                    payload: response
                })
                resolve(response);
            })
                .catch(function (error) {
                    dispatch({
                        type: ADD_SUPPLY_ERROR,
                        payload: error
                    })
                    reject(error)
                })
        })
    }
}

export const resetAddSupplyData = () => {
    return dispatch => {
        dispatch({
            type: RESET_ADD_SUPPLY
        })
    }
}
